<template>
  <eg-modal
    id="essay-regrade-modal"
    :title="`${$t('essays.regrade')}: ${essay.name}`"
    :ok-title="$t('essays.regrade')"
    ok-variant="info"
    size="lg"
    centered
  >
    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center">
        <eg-button type="ordinary" @click="close">{{
          $t("common.close")
        }}</eg-button>
        <eg-button
          class="ml-2"
          type="primary"
          :is-loading="loadingFeedback"
          :disabled="loadingFeedback"
          @click="regradeEssay"
        >
          {{ $t("essays.regrade") }}
        </eg-button>
      </div>
    </template>
    <div v-if="Object.keys(gradingDetails).length > 0">
      <grading-details-form
        v-model="gradingDetails"
        :rubric="folder?.gradingDetails?.rubric"
      />
    </div>
    <div v-else>
      <eg-b-overlay :show="true">
        <div class="d-flex justify-content-center align-items-center">
          <eg-b-spinner variant="info" />
        </div>
      </eg-b-overlay>
    </div>
  </eg-modal>
</template>

<script>
import { reGradeEssay } from "@/api";
import GradingDetailsForm from "@/components/rubrics/gradingDetails/grading_details_form.vue";

export default {
  components: {
    GradingDetailsForm,
  },

  inject: ["workspacesProvider"],

  props: {
    essay: {
      type: Object,
      required: true,
    },
    resolve: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      gradingDetails: {},
      loadingFeedback: false,
    };
  },

  computed: {
    folderId() {
      return this.$route.params.id || this.essay.folderId;
    },

    workspaceKey() {
      return (
        this.$route.params.workspaceKey ||
        this.workspacesProvider.findWorkspaceKeyByFolderId(this.folderId)
      );
    },

    folder() {
      return this.workspacesProvider.getFolderById(
        this.workspaceKey,
        this.folderId
      );
    },
  },

  async created() {
    if (!this.folder?.gradingDetails) {
      await this.workspacesProvider.loadFolderById(
        this.workspaceKey,
        this.folderId
      );
    }

    const {
      level,
      intensity,
      length,
      sourceMaterialId,
      inputLanguageId,
      outputLanguageId,
      customInstructions,
    } = this.folder.gradingDetails;

    this.gradingDetails = {
      level,
      intensity,
      length,
      sourceMaterialId,
      inputLanguageId,
      outputLanguageId,
      customInstructions,
    };
  },

  methods: {
    async regradeEssay() {
      try {
        this.$emit("startRegrade");
        await this.regradeRequest(this.essay.id, this.gradingDetails);
        this.$emit("finishRegrade");
        this.resolve(true);
        this.$nextTick(() => {
          this.$egModal.hide("essay-regrade-modal");
        });
      } catch (error) {
        this.$emit("finishRegrade");
      }
    },

    async regradeRequest(essayId, payload = {}) {
      try {
        this.loadingFeedback = true;

        await reGradeEssay(essayId, { gradingDetails: payload });

        this.$showToastSuccess(this.$t("essays.essayRequeued"), {
          title: this.$t("common.success"),
        });
        this.loadingFeedback = false;
      } catch (error) {
        this.loadingFeedback = false;
      }
    },
  },
};
</script>
